import React, { useState } from "react";
import {
  Paper,
  Button,
  FormControl,
  Input,
  InputLabel
} from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";
import { withRouter } from "react-router-dom";
import firebase from "../firebase";
import Permiso from "../Permiso";

const styles = theme => ({
  main: {
    height: "100vh",
    width: "auto",
    display: "block",
    marginLeft: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3,
    [theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
      width: 400,
      marginLeft: "auto",
      marginRight: "auto"
    }
  },
  paper: {
    //marginTop: theme.spacing.unit * 8,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme
      .spacing.unit * 3}px`
  },
  avatar: {
    margin: theme.spacing.unit
  },
  form: {
    width: "100%",
    marginTop: theme.spacing.unit
  },
  submit: {
    marginTop: theme.spacing.unit * 3
  },
  logo: {
    width: "150px",
    display: "block",
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: "15px"
  }
});

function SignIn(props) {
  const { classes } = props;

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  return (
    <div
      style={{
        backgroundImage:
          "url(https://i.ibb.co/F8yrd5g/188a54d2-e0af-4083-bea9-f3008045a5bc.jpg)",
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat"
      }}
    >
      <div>
        <main className={classes.main}>
          <Paper className={classes.paper}>
            <div className={classes.avatar}>
              <img
                className={classes.logo}
                src="https://i.ibb.co/BGCyZq2/LOGO-BOCLAIMS-REGISTRADO.jpg"
                alt="Boclaims logo"
              />
            </div>
            <form
              className={classes.form}
              onSubmit={e => e.preventDefault() && false}
            >
              <FormControl margin="normal" required fullWidth>
                <InputLabel htmlFor="email">Email</InputLabel>
                <Input
                  id="email"
                  name="email"
                  autoComplete="off"
                  autoFocus
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                />
              </FormControl>
              <FormControl margin="normal" required fullWidth>
                <InputLabel htmlFor="password">Contrasena</InputLabel>
                <Input
                  name="password"
                  type="password"
                  id="password"
                  autoComplete="off"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                />
              </FormControl>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                onClick={login}
                className={classes.submit}
              >
                Iniciar
              </Button>
            </form>
          </Paper>
        </main>
      </div>
    </div>
  );

  async function login() {
    try {
      await firebase.login(email, password);
      Autorizacion();
      /* if(window.respuesta.status){ props.history.replace("/dashboard/principal"); 
        console.log("entro al IF", window.respuesta.status)
    }else{
        alert("el usuario se encuentra desactivado, contactese con el aministrador")
      }*/
    } catch (error) {
      alert(error.message);
    }
  }

  async function Autorizacion() {
    async function foo() {
      const k = new Permiso(); //Aqui hago instancia para llamar a la function que esta en Permiso.js
      const g = await k.Permiso(function(ans, status) {
        /*qui la llamo y le paso una funcion como parametro
        console.log("el usuario tiene un status   :  ", status.status)
        console.log(ans, "la ans del Permiso en usuario");
        console.log(
          window.respuesta,
          "log antes de la asignacion de la variable global"
        );*/
        window.respuesta = ans;
        window.respuestaA = window.respuesta.checkedA;
        window.respuesta.status = status.status;
        /* console.log(
          window.respuestaA,
          "log despues de la asignacion de la variable global"
        );
        console.log(window.respuesta.checkedA, "*** lectura ***");
        console.log(window.respuesta.checkedB, "*** agregar ***");
        console.log(window.respuesta.checkedC, "*** editar ***");
        console.log(window.respuesta.checkedD, "*** checkedD ***");
        console.log(window.respuesta.checkedE, "*** checkedE ***");
        console.log(window.respuesta.checkedF, "*** checkedF ***");
        console.log(window.respuesta.checkedG, "*** checkedG ***");
        console.log(window.respuesta.checkedH, "*** checkedH ***");
        console.log(window.respuesta.checkedI, "*** checkedI ***");
        console.log(window.respuesta.checkedJ, "*** checkedJ ***");
        console.log(status.status  , "*** status ***");*/

        var Permisos = {
          checkedA: window.respuesta.checkedA,
          checkedB: window.respuesta.checkedB,
          checkedC: window.respuesta.checkedC,
          checkedD: window.respuesta.checkedD,
          checkedE: window.respuesta.checkedE,
          checkedF: window.respuesta.checkedF,
          checkedG: window.respuesta.checkedG,
          checkedH: window.respuesta.checkedH,
          checkedI: window.respuesta.checkedI,
          checkedJ: window.respuesta.checkedJ,
          status: status.status
        };

        // Put the object into storage
        localStorage.setItem("Permisos", JSON.stringify(Permisos));

        // console.log("Los permisos: ", JSON.parse(Autorizacion));

        if (status.status) {
          if (window.respuesta.checkedA) {
            props.history.replace("/dashboard/principal");
          } else {
            props.history.replace("/dashboard/reportes");
          }
        } else {
          alert(
            "Lo sentimos, el usuario que intenta usar ha sido desactivado."
          );
          firebase.logoutDes();
        }

        return ans;
      });
      // console.log(g, "la g del foo")
      return g;
    }
    //this.setState({ open: await foo() })

    await foo();
    //AAQUI pero llega indefinida la varuiable, de hecho lo que pongo aqui se ejecuta antes, jijitl
    // console.log(y, "hay algo aqui? no lo hay")
    // console.log(await foo()," el foo a ver que pedo!!!!!!!")
    //console.log(window.respuesta, "log final de la asignacion de la variable global")
  }
}

export default withRouter(withStyles(styles)(SignIn));
